export default "__VITE_ASSET__BA79xmpf__"